import { useState, useCallback } from 'react';

function useDefaultModal() {
    const [dataModal, setDataModal] = useState({ show: false, type: '', message: '', onClose: null });

    const showDefaultModal = useCallback((type, message, onClose = null) => {
        setDataModal({ show: true, type, message, onClose });
    }, []);

    const closeDefaultModal = useCallback(() => {
        setDataModal(prevModalData => {
            if (prevModalData.onClose) {
                prevModalData.onClose();
            }
            return { ...prevModalData, show: false, onClose: null };
        });
    }, []);

    return {
        setDefaultModal: {
            show: dataModal.show,
            type: dataModal.type,
            message: dataModal.message,
            onClose: closeDefaultModal
        },
        showDefaultModal,
        closeDefaultModal,
    };
}

export default useDefaultModal;
